import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/youtube_icon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-0575e30b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-header mb-0" }, "Gerenciar perfil")
], -1))
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "d-flex mb-3" }
const _hoisted_7 = { class: "position-relative" }
const _hoisted_8 = { class: "position-absolute avatar-content w-100 p-3 bottom-0 start-0 end-0" }
const _hoisted_9 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_10 = { class: "badge bg-primary" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_12 = { class: "ms-3" }
const _hoisted_13 = {
  key: 0,
  class: "badge bg-success mb-2 rounded-4"
}
const _hoisted_14 = { class: "text-subtitle mb-2" }
const _hoisted_15 = { class: "text-label" }
const _hoisted_16 = { class: "text-paragraph" }
const _hoisted_17 = { class: "d-flex mb-4" }
const _hoisted_18 = { class: "border rounded-4 px-2 border-2 text-paragraph me-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-star text-warning" }, null, -1))
const _hoisted_20 = { class: "border rounded-4 px-2 border-2 text-paragraph" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user-group" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-3" }, null, -1))
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-12 col-md-6" }
const _hoisted_25 = { class: "col-12 col-md-6" }
const _hoisted_26 = { class: "card-body" }
const _hoisted_27 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-star" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-right" }, null, -1))
const _hoisted_30 = {
  key: 0,
  class: "progress"
}
const _hoisted_31 = {
  key: 1,
  class: "text-subtitle text-info mb-0"
}
const _hoisted_32 = { class: "card" }
const _hoisted_33 = { class: "card-body" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-eye" }, null, -1))
const _hoisted_35 = { class: "d-flex align-items-center justify-content-between border-bottom my-4" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, "Últimos 30 dias", -1))
const _hoisted_37 = { class: "text-subtitle" }
const _hoisted_38 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, "Todas visualizações", -1))
const _hoisted_40 = { class: "text-subtitle" }
const _hoisted_41 = {
  key: 1,
  class: "text-subtitle text-info mb-0"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "mb-0 text-paragraph" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-right ms-auto text-primary" }, null, -1))

import { useMainStore } from "@/store";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import {
  EOffcanvasViews,
  IOffcanvasConfig,
  OffcanvasViewKey,
  OffcanvasViewsConfig,
  navigateCanvas,
} from "@/views/OffcanvasViews/OffcanvasViewsConfig";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileSettings',
  setup(__props) {

const { session } = useMainStore();

const isPremium = session?.is_plus;
const profileLink = `${process.env.VUE_APP_WEB_APP_URL}psi/${session?.slug}`;

const toggle = computed(() => window.innerWidth > 964);

const actions = [
  {
    icon: "fa-solid fa-user",
    label: "Visualizar meu perfil",
    action: () => navigate(OffcanvasViewsConfig.my_profile),
  },
  {
    icon: "fa-solid fa-globe",
    label: "Visualizar meu perfil na web",
    action: () => window.open(profileLink, "_blank"),
  },
  {
    icon: "fa-solid fa-user-pen",
    label: "Gerenciar e editar perfil",
    action: () => navigate(OffcanvasViewsConfig.profile_edit),
  },
  {
    icon: "fa-solid fa-share",
    label: "Compartilhar horário avulso",
    action: () => navigate(OffcanvasViewsConfig.share_schedule),
  },
  {
    icon: "fa-solid fa-share",
    label: "Compartilhar perfil",
    action: () => {
      navigator.clipboard.writeText(profileLink);
      EventBus.$emit(EventBusNames.SHOW_TOAST, {
        title: "Link copiado",
        msg: `O link de seu perfil foi copiado para você poder compartilhar`,
      });
    },
  },
];

const handlePsiappAds = () => {
  const phone = process.env.VUE_APP_WHATSAPP_NUMBER;
  const msg = process.env.VUE_APP_WHATSAPP_MESSAGE;
  const uri = `https://api.whatsapp.com/send?phone=${phone}&text=${msg}`;
  window.open(uri, "_blank");
};

const handleImproveYourProfile = () => {
  if (isPremium) {
    navigate(OffcanvasViewsConfig.improve_your_profile);
    return;
  }
  navigateCanvas(EOffcanvasViews.subscription);
};

const navigate = (view: IOffcanvasConfig) => {
  navigateCanvas(view.path as OffcanvasViewKey, null, toggle.value);
};

const handleProfile = () => {
  navigate(OffcanvasViewsConfig.my_profile);
};

const handleProfileEdit = () => {
  navigate(OffcanvasViewsConfig.profile_edit);
};

return (_ctx: any,_cache: any) => {
  const _component_AvatarComponent = _resolveComponent("AvatarComponent")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_AvatarComponent),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, "R$" + _toDisplayString(_unref(session)?.appointment_price), 1),
                  _hoisted_11
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_unref(session)?.online)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Disponível agora "))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(session)?.name), 1),
              _createElementVNode("p", _hoisted_15, " CRP: " + _toDisplayString(_unref(session)?.crp) + " | " + _toDisplayString(_unref(session)?.address_state), 1)
            ])
          ]),
          _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(session)?.bio), 1),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("span", _hoisted_18, [
              _hoisted_19,
              _createTextVNode(" " + _toDisplayString(_unref(session)?.ratings_as_psi_count), 1)
            ]),
            _createElementVNode("span", _hoisted_20, [
              _hoisted_21,
              _createTextVNode(" " + _toDisplayString(_unref(session)?.valid_appointments_as_psi_count), 1)
            ])
          ]),
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_Button, {
                label: "Visualizar perfil",
                outline: "",
                fullWidth: "",
                onOnClick: handleProfile
              })
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_Button, {
                label: "Editar perfil",
                color: "primary",
                fullWidth: "",
                onOnClick: handleProfileEdit
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "card cursor-pointer",
        onClick: handleImproveYourProfile
      }, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("p", {
              class: _normalizeClass(["mb-0 text-subtitle", { 'text-muted': !_unref(isPremium) }])
            }, [
              _hoisted_28,
              _createTextVNode(" Melhore seu perfil ")
            ], 2),
            _hoisted_29
          ]),
          _createElementVNode("p", {
            class: _normalizeClass(["text-paragraph", { 'text-muted': !_unref(isPremium) }])
          }, " Dicas para deixar seu perfil mais atrativo para os pacientes. ", 2),
          (_unref(isPremium))
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("div", {
                  class: "progress-bar bg-success",
                  role: "progressbar",
                  style: _normalizeStyle({
                width: `${_unref(session)?.profile_improvement_values?.percentage}%`,
              })
                }, null, 4)
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_31, " Exclusivo para assinantes do Psiapp+ "))
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("p", {
            class: _normalizeClass(["text-subtitle", { 'text-muted': !_unref(isPremium) }])
          }, [
            _hoisted_34,
            _createTextVNode(" Visualizações ")
          ], 2),
          _createElementVNode("p", {
            class: _normalizeClass(["text-paragraph", { 'text-muted': !_unref(isPremium) }])
          }, " Quantidade de pacientes que visualizaram seu perfil. ", 2),
          (_unref(isPremium))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("p", _hoisted_37, _toDisplayString(_unref(session)?.total_views_this_month), 1)
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("p", _hoisted_40, _toDisplayString(_unref(session)?.total_views), 1)
                ])
              ], 64))
            : (_openBlock(), _createElementBlock("p", _hoisted_41, " Exclusivo para assinantes do Psiapp+ "))
        ])
      ]),
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(actions, (action, index) => {
        return _createElementVNode("div", {
          class: _normalizeClass(["d-flex align-items-center py-4 cursor-pointer", { 'border-bottom': index !== actions.length - 1 }]),
          key: index,
          onClick: action.action
        }, [
          _createElementVNode("p", _hoisted_43, [
            _createElementVNode("i", {
              class: _normalizeClass([action.icon, "text-primary"])
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(action.label), 1)
          ]),
          _hoisted_44
        ], 10, _hoisted_42)
      }), 64))
    ])
  ]))
}
}

})